console.log("get_discount_wrapper.js runnnn")
document.addEventListener('DOMContentLoaded', function () {
  const bundleRight = document.querySelector('.pc-bundle__right');
  const saveBigBtn = document.querySelector('#saveBigBtn');
  const saveBigBtnPrice = document.querySelector('.saveBigBtn_price');
  const noteComparePrice = document.querySelector('.bundle-savings__note .pc-price--strike');
  const notePrice = document.querySelector('.bundle-savings__note .pc-price');
  const noteSave = document.querySelector('.bundle-savings__note .pc-badge--save');

  /** ----------------- Tooltip ----------------- **/

  function hasSelectedPCIDInHref() {
    const parts = getHrefParts();
    if (!parts) return false;
    return parts.path.includes('selectedPCID') || parts.href.includes('selectedPCID');
  }
  function lockBtn() {
    saveBigBtn?.classList.add('pc-cta--lock');
  }
  function unlockBtn() {
    saveBigBtn?.classList.remove('pc-cta--lock', 'pc-cta--showtip');
  }
  /** ----------------- HREF helpers ----------------- **/

  function getHrefParts() {
    if (!saveBigBtn) return null;
    const href = saveBigBtn.getAttribute('href') || '';
    const [path, query = ''] = href.split('?');
    const cartIdx = path.indexOf('/cart/');
    if (cartIdx === -1) return null;
    const prefix = path.slice(0, cartIdx + 6); // '/cart/' include
    const listStr = path.slice(cartIdx + 6); // "id:qty,id2:qty2,..."
    const items = listStr.split(',').filter(Boolean);
    return { href, path, query, prefix, listStr, items };
  }

  function setHrefItems(items, query, prefix) {
    const newPath = prefix + items.join(',');
    const newHref = query ? `${newPath}?${query}` : newPath;
    saveBigBtn.setAttribute('href', newHref);
  }

  function updateNthVariantInHref(nIndex, newVariantId) {
    const parts = getHrefParts();
    if (!parts || !newVariantId) return;
    const { items, query, prefix } = parts;
    if (nIndex < 0 || nIndex >= items.length) return;
    const old = items[nIndex];
    const qty = old.includes(':') ? old.split(':')[1] : '1';
    items[nIndex] = `${newVariantId}:${qty}`;
    setHrefItems(items, query, prefix);
  }

  /** ----------------- IMAGE helpers ----------------- **/
  function setImgSrcAndSrcset(imgEl, rawUrl, widths = [352, 360]) {
    if (!imgEl || !rawUrl) return;
    const safeUrl = String(rawUrl).replace(/&amp;/g, '&');
    const stripWidth = (u) => u.replace(/([?&])width=\d+(&?)/i, '$1').replace(/[?&]$/, '');
    const base = stripWidth(safeUrl);
    const sep = base.includes('?') ? '&' : '?';

    const maxW = Math.max.apply(null, widths);
    imgEl.setAttribute('src', `${base}${sep}width=${maxW}`);

    const srcset = widths.map((w) => `${base}${sep}width=${w} ${w}w`).join(', ');
    imgEl.setAttribute('srcset', srcset);
    if (!imgEl.getAttribute('sizes')) {
      imgEl.setAttribute('sizes', '(max-width: 360px) 100vw, 360px');
    }
  }

  /** ----------------- DD ----------------- **/
  const dropdownMap = new WeakMap(); // dropdownEl -> { cardEl, cartIndex, isProduct }

  function mapCardsToCartIndexes() {
    if (!bundleRight) return;
    const productCard = bundleRight.querySelector('.bundle-card--product');
    const allCards = Array.from(bundleRight.querySelectorAll('.bundle-card'));
    const parts = getHrefParts();
    const itemCount = parts ? parts.items.length : 0;

    if (productCard) {
      const dropdown = productCard.querySelector('.bundle-dd');
      if (dropdown) {
        dropdownMap.set(dropdown, { cardEl: productCard, cartIndex: 0, isProduct: true });
      }
    }

    let idx = 1;
    for (const card of allCards) {
      if (card === productCard) continue;
      const dropdown = card.querySelector('.bundle-dd');
      if (!dropdown) continue;
      if (idx < itemCount) {
        dropdownMap.set(dropdown, { cardEl: card, cartIndex: idx, isProduct: false });
      }
      idx++;
    }
  }
  mapCardsToCartIndexes();

  /** ----------------- UI updates ----------------- **/
  function updateMerchantUIFromItem(cardEl, itemEl) {
    if (!cardEl || !itemEl) return;
    const newImg = itemEl.dataset.image;
    const priceFormatted = itemEl.dataset.priceFormatted || '';
    const compareFormatted = itemEl.dataset.compareFormatted || '';

    const imgEl = cardEl.querySelector('.bundle-card__img');
    const priceEl = cardEl.querySelector('.bundle-card__price .pc-price');
    const compareEl = cardEl.querySelector('.bundle-card__price .pc-price--strike');

    if (imgEl && newImg) {
      setImgSrcAndSrcset(imgEl, newImg, [352, 360]);
      imgEl.setAttribute('alt', itemEl.dataset.value || imgEl.getAttribute('alt') || '');
    }
    if (priceEl) priceEl.innerHTML = priceFormatted;

    if (compareEl) {
      if (compareFormatted) {
        compareEl.innerHTML = compareFormatted;
        compareEl.style.display = '';
      } else {
        compareEl.innerHTML = '';
        compareEl.style.display = 'none';
      }
    }
  }

  function contactBannerVariants(id) {
    const bannerVariants = document.querySelectorAll('.variantsDD .product__add-to-cart-button');
    bannerVariants.forEach((btn) => {
      if (btn.dataset.atc === id) btn.click();
    });
  }

  function initSelectedState() {
    if (!bundleRight) return;
    const allDropdowns = bundleRight.querySelectorAll('.bundle-dd');
    allDropdowns.forEach((dd) => {
      const selected = dd.querySelector('.bundle-dd__selected-multi');
      if (!selected) return;
      if (!selected.dataset.variantId) {
        const firstItem = dd.querySelector('.bundle-dd__list .bundle-dd__item');
        if (firstItem) {
          selected.dataset.variantId = firstItem.dataset.variantId;
          const meta = dropdownMap.get(dd);
          if (meta && !meta.isProduct) {
            updateMerchantUIFromItem(meta.cardEl, firstItem);
          }
        }
      }
    });
    if (hasSelectedPCIDInHref()) lockBtn();
    else unlockBtn();
  }
  initSelectedState();

  function updateBundleUIPrices(el, oldSelectedPrice, oldSelectedCompare) {
    let selectedEl = el.querySelector('.bundle-dd__selected-multi');
    let dataNoteComparePrice = noteComparePrice.dataset.noteCompare;
    let dataNotePrice = notePrice.dataset.notePrice;

    let uiPrice = Number(dataNotePrice) + Number(selectedEl.dataset.price) - Number(oldSelectedPrice);
    notePrice.innerHTML = `<span class="money">${formatMoney(uiPrice)}</span>`;
    notePrice.dataset.notePrice = uiPrice;
    saveBigBtnPrice.innerHTML = `<span class="money">${formatMoney(uiPrice)}</span>`;

    let uiCompare = Number(dataNoteComparePrice) + Number(selectedEl.dataset.compare) - Number(oldSelectedCompare);
    noteComparePrice.dataset.noteCompare = uiCompare;
    noteComparePrice.innerHTML = `<span class="money">${formatMoney(uiCompare)}</span>`;

    noteSave.innerHTML = `<span class="money">${formatMoney(uiCompare - uiPrice)}</span>`;
    noteSave.dataset.noteSave = uiCompare - uiPrice;
  }

  function redirectSelection() {
    document.querySelector('.bundle-dd_pc').classList.add('active');
    if (window.innerWidth < 768) {
      const productCard = document.querySelector('.bundle-card--product');
      if (productCard) {
        productCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  /** ----------------- ACTIONS ----------------- **/
  if (bundleRight) {
    bundleRight.addEventListener('click', (e) => {
      const dropdown = e.target.closest('.bundle-dd');

      document.querySelectorAll('.bundle-dd').forEach((d) => {
        if (d !== dropdown) d.classList.remove('active');
      });
      if (!dropdown) return;



      const selected = dropdown.querySelector('.bundle-dd__selected-multi');
      
      console.log("selected-->",selected)
      console.log("selected.contains(e.target)-->",selected.contains(e.target))


      if (selected && selected.contains(e.target)) {
        dropdown.classList.toggle('active');
        return;
      }
      console.log("bundleRight return none")

      const item = e.target.closest('.bundle-dd__item');
      if (item && selected) {
        selected.textContent = item.textContent.trim();
        selected.dataset.variantId = item.dataset.variantId;

        let oldSelectedPrice = selected.dataset.price;
        let oldSelectedCompare = selected.dataset.compare;
        selected.dataset.price = item.dataset.price;
        selected.dataset.compare = item.dataset.compare;

        dropdown.classList.remove('active');

        const meta = dropdownMap.get(dropdown);
        if (!meta) return;

        updateNthVariantInHref(meta.cartIndex, selected.dataset.variantId);

        if (meta.isProduct) {
          contactBannerVariants(selected.dataset.variantId);
          if (!hasSelectedPCIDInHref()) unlockBtn();
        } else {
          updateMerchantUIFromItem(meta.cardEl, item);
          updateBundleUIPrices(meta.cardEl, oldSelectedPrice, oldSelectedCompare);
        }
      }
    });
  }

  /** ----------------- CTA Spinner ----------------- **/
  if (saveBigBtn) {
    saveBigBtn.addEventListener('click', (e) => {
      if (saveBigBtn.classList.contains('pc-cta--lock') || hasSelectedPCIDInHref()) {
        e.preventDefault();
        e.stopPropagation();
        saveBigBtn.classList.add('pc-cta--showtip');
        setTimeout(redirectSelection, 1000);
        setTimeout(() => saveBigBtn.classList.remove('pc-cta--showtip'), 1500);
        return;
      }
      const span = saveBigBtn.querySelector('span');
      const spinner = saveBigBtn.querySelector('.loading__spinner');
      if (span) span.style.display = 'none';
      if (spinner) spinner.classList.remove('hidden');
    });
  }

  // === Merchandise MODAL ===
  function initmerchandiseModal() {
    const merchandiseCard = document.getElementById('merchandiseCard');
    if (!merchandiseCard) return;

    const merchandiseImg = document.getElementById('merchandiseImg');
    const merchandiseZoom = document.getElementById('merchandiseZoomBtn');
    const merchandiseDD = document.getElementById('merchandiseDD');
    const merchandiseSelected = document.getElementById('merchandiseSelected');
    const merchandiseList = document.getElementById('merchandiseList');
    const merchandisePrice = document.getElementById('merchandisePrice');
    const merchandiseCompare = document.getElementById('merchandiseCompare');

    const modal = document.getElementById('merchandiseModal');
    const mTitleEl = document.getElementById('merchandiseModalVariantTitle');
    const mPriceEl = document.getElementById('merchandiseModalPrice');
    const mCompareEl = document.getElementById('merchandiseModalCompare');
    const selectBtn = document.getElementById('merchandiseSelectBtn');

    const mainWrap = document.querySelector('#merchandiseSwiper .swiper-wrapper');
    const thumbsWrap = document.querySelector('#merchandiseThumbs .swiper-wrapper');

    // 
    const wItems = Array.from((merchandiseList || document.createElement('div')).querySelectorAll('.bundle-dd__item'));
    const wData = wItems.map(li => ({
      id: li.dataset.variantId,
      title: li.dataset.value,
      image: li.dataset.imageZoom || li.dataset.image,
      thumb: li.dataset.thumb || li.dataset.image,
      price: Number(li.dataset.price || 0),
      priceFormatted: li.dataset.priceFormatted || '',
      compare: li.dataset.compare ? Number(li.dataset.compare) : null,
      compareFormatted: li.dataset.compareFormatted || ''
    }));
    if (!wData.length) return;

    // 
    if (mainWrap && thumbsWrap) {
      wData.forEach(v => {
        const s = document.createElement('div');
        s.className = 'swiper-slide';
        s.innerHTML = `<img src="${v.image}" alt="${v.title}">`;
        mainWrap.appendChild(s);

        const t = document.createElement('div');
        t.className = 'swiper-slide';
        t.innerHTML = `<img src="${v.thumb}" alt="${v.title}">`;
        thumbsWrap.appendChild(t);
      });
    }

    // 
    const wThumbs = new Swiper('#merchandiseThumbs', {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true
    });
    const wMain = new Swiper('#merchandiseSwiper', {
      spaceBetween: 10,
      navigation: { nextEl: '#merchandiseNext', prevEl: '#merchandisePrev' },
      thumbs: { swiper: wThumbs },
      on: {
        slideChange() {
          const idx = this.activeIndex || 0;
          syncmerchandiseModal(idx);
        }
      }
    });

    function setMoneyNode(node, valueFormatted, show) {
      if (!node) return;
      if (show && valueFormatted) {
        node.innerHTML = valueFormatted;
        node.style.display = '';
      } else {
        node.innerHTML = '';
        node.style.display = 'none';
      }
    }

    function syncmerchandiseModal(idx) {
      const v = wData[idx];
      if (!v) return;
      mTitleEl.textContent = v.title || '';
      // mPriceEl.textContent = v.priceFormatted || '';
      setMoneyNode(mPriceEl, v.priceFormatted, Number(v.price));
      setMoneyNode(mCompareEl, v.compareFormatted, v.compare && Number(v.compare) > Number(v.price));
    }

    function openmerchandiseModal(startIndex) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (typeof startIndex === 'number') {
        wMain.slideTo(startIndex, 0);
        wThumbs.slideTo(startIndex, 0);
        syncmerchandiseModal(startIndex);
      }
    }
    function closemerchandiseModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    modal.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-close-modal')) closemerchandiseModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closemerchandiseModal();
    });

    // 
    merchandiseZoom?.addEventListener('click', () => {
      const currentTitle = (merchandiseSelected?.textContent || '').trim();
      const idx = wData.findIndex(v => v.title === currentTitle);
      openmerchandiseModal(idx >= 0 ? idx : 0);
    });

    // 
    selectBtn?.addEventListener('click', () => {
      const idx = wMain.activeIndex || 0;
      const v = wData[idx];
      if (!v) return;

      const oldPrice = Number(merchandiseSelected?.dataset.price || 0);
      const oldCompare = Number(merchandiseSelected?.dataset.compare || 0);

      // 
      if (merchandiseSelected) {
        merchandiseSelected.textContent = v.title;
        merchandiseSelected.dataset.variantId = String(v.id || '');
        merchandiseSelected.dataset.price = String(v.price || 0);
        merchandiseSelected.dataset.compare = v.compare != null ? String(v.compare) : '';
      }

      // 
      if (merchandiseImg && v.image) {
        setImgSrcAndSrcset(merchandiseImg, v.image, [352, 360]);
        merchandiseImg.setAttribute('alt', v.title || merchandiseImg.getAttribute('alt') || '');
      }

      // 
      if (merchandisePrice) merchandisePrice.innerHTML = v.priceFormatted || '';
      setMoneyNode(merchandiseCompare, v.compareFormatted, v.compare && Number(v.compare) > Number(v.price));

      // 
      if (merchandiseList) {
        [...merchandiseList.querySelectorAll('.bundle-dd__item')].forEach((li) => {
          li.classList.toggle('is-active', li.getAttribute('data-value') === v.title);
        });
      }

      // 
      const meta = dropdownMap.get(merchandiseDD);
      if (meta) {
        updateNthVariantInHref(meta.cartIndex, v.id);
        updateBundleUIPrices(merchandiseCard, oldPrice, oldCompare);
      }

      // 
      if (!hasSelectedPCIDInHref()) {
        if (typeof unlockBtn === 'function') unlockBtn();
      }

      closemerchandiseModal();
    });

    syncmerchandiseModal(0);
  }

  /** ----------------- SAVE AMOUNT update  ----------------- **/

  const formatMoney = (amount) => {
    return `$${(amount / 100).toFixed(2)}`;
  };

  initmerchandiseModal();

});
